<script>
  export let item
  export let base
</script>

<div class="row h-100 no-gutters white pos-rel">

  {#if item.images[0]}
    <img src={item.images[0].url} class="img-full" alt="header" />
  {:else if item.image}
    <img src={item.image} class="img-full" alt="header" />
  {:else}
    <img
      src="{base}themes/PlayFair/img/header-space.jpg"
      alt="header"
      class="img-full" />
  {/if}

  <div class="col-sm-12 text-center pos-abs" style="margin-top: 7%;">
    <h1>
      {#if item.title}{item.title}{:else}Sitefiction{/if}
    </h1>
    <div class="w-50 m-auto">
      <p>
        {#if item.tagline}{item.tagline}{:else}Lorem ipsum dolor site amet.{/if}
      </p>
    </div>
  </div>

</div>
